import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "selectAll", "selectionCount"]
  static values = { max: Number }

  connect() {
    this.syncUI()
  }

  toggleAll(event) {
    const checked = event.target.checked

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = checked
      this.updateLabel(checkbox)
    })

    this.syncUI()
  }

  toggleItem(event) {
    const checkbox = event.target

    if (this.hasMaxValue && checkbox.checked) {
      const checked = this.itemTargets.filter(cb => cb.checked)

      if (checked.length > this.maxValue) {
        this.itemTargets.forEach((cb) => {
          if (cb !== checkbox) {
            cb.checked = false
            this.updateLabel(cb)
          }
        })
      }
    }

    this.updateLabel(checkbox)
    this.syncUI()
  }

  syncUI() {
    const total = this.itemTargets.length
    const selected = this.itemTargets.filter(cb => cb.checked).length

    // Selected counter
    if (this.hasSelectionCountTarget) {
      this.selectionCountTarget.textContent = `Selected (${selected})`
    }

    // Select all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = total > 0 && selected === total
      this.selectAllTarget.indeterminate =
        selected > 0 && selected < total
    }
  }

  updateLabel(checkbox) {
    const label = checkbox.closest("label")
    if (!label) return

    label.classList.toggle("selected", checkbox.checked)
  }
}
